var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.073 29.2988C13.4307 29.5441 13.7883 29.6667 14.146 29.6667C14.429 29.6667 14.712 29.5899 15.0541 29.4971C15.1443 29.4726 15.2387 29.447 15.3382 29.4215L27.2603 22.3103C27.9757 21.9425 28.3333 21.2069 28.3333 20.3487C28.3333 19.4904 27.9757 18.7548 27.2603 18.387L15.3382 11.2759C14.6229 10.908 13.7883 10.908 13.073 11.2759C12.3577 11.6437 12 12.3793 12 13.2375V27.3372C12 28.1954 12.3577 28.931 13.073 29.2988Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export default ForwardRef;